<div class="multilingual-input-wrapper">
    <!-- Simple Header -->
    <div class="compact-header">
        <span class="component-label">{{ label | translate }}</span>

        <!-- Simple Language Selector -->
        <div class="add-language-compact" *ngIf="availableLanguages.length > 0">
            <mat-select #languageSelect class="language-selector"
                (selectionChange)="addLanguage(languageSelect.value); languageSelect.value = null"
                placeholder="{{ 'Add Language' | translate }}">
                <mat-option *ngFor="let lang of availableLanguages" [value]="lang">
                    {{ lang.flag }} {{ lang.name }}
                </mat-option>
            </mat-select>
        </div>
    </div>

    <!-- Simple Language Forms -->
    <form [formGroup]="multilingualForm" class="compact-multilingual-form">
        <div formArrayName="languages" class="compact-languages-container">
            <!-- Empty State -->
            <div *ngIf="languagesArray.length === 0" class="empty-state">
                <mat-icon class="empty-icon">translate</mat-icon>
                <span class="empty-text">{{ 'No translations added yet' | translate }}</span>
                <small class="empty-hint">{{ 'Add a language above to get started' | translate }}</small>
            </div>

            <!-- Simple Language Cards -->
            <div *ngFor="let languageGroup of languagesArray.controls; let i = index; trackBy: trackByLanguageCode"
                [formGroupName]="i" class="compact-language-card">

                <!-- Simple Language Header -->
                <div class="compact-language-header">
                    <div class="language-badge">
                        <span class="flag">{{ getLanguageFlag(languageGroup.get('languageCode')?.value) }}</span>
                        <span class="lang-code">{{ languageGroup.get('languageCode')?.value | uppercase }}</span>
                    </div>

                    <span class="language-name">{{ getLanguageName(languageGroup.get('languageCode')?.value) }}</span>

                    <!-- Simple Remove Button -->
                    <button type="button" mat-icon-button class="compact-remove-btn" (click)="removeLanguage(i)"
                        [disabled]="!canRemoveLanguage(languageGroup.get('languageCode')?.value)"
                        [matTooltip]="'Remove Language' | translate">
                        <mat-icon class="small-icon">close</mat-icon>
                    </button>
                </div>

                <!-- Simple Fields -->
                <div class="compact-fields-container">
                    <div *ngFor="let fieldName of config.fieldNames; trackBy: trackByFieldName"
                        class="compact-field-group">
                        <mat-form-field appearance="outline" class="compact-field">
                            <mat-label class="compact-label">
                                {{ getFieldLabel(fieldName) }}
                                <span *ngIf="isFieldRequired(fieldName)" class="required-dot">•</span>
                            </mat-label>

                            <input matInput [formControlName]="fieldName.toLowerCase()"
                                [placeholder]="getPlaceholder(fieldName)" [maxlength]="maxLength"
                                (blur)="onTouchedField()" [disabled]="disabled" class="compact-input" />

                            <!-- Simple Character Counter -->
                            <mat-hint align="end" *ngIf="maxLength" class="compact-hint">
                                {{ getFieldValueLength(languageGroup, fieldName) }}/{{ maxLength }}
                            </mat-hint>

                            <!-- Simple Error Messages -->
                            <mat-error *ngIf="hasError(i, fieldName)" class="compact-error">
                                {{ getErrorMessage(i, fieldName) }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <!-- Simple Validation Messages -->
    <div class="compact-validation-messages"
        *ngIf="multilingualForm.invalid && (multilingualForm.dirty || multilingualForm.touched)">
        <mat-error class="compact-global-error">
            {{ 'Please fill in all required fields for all languages' | translate }}
        </mat-error>
    </div>
</div>